export const DEBOUNCE_DELAY = 200;
export const defaultPager = { page: 1, pageSize: 10 };

export const inOrderColumns = [
  {
    columnName: "desc",
    displayNameKey: "Descending"
  },
  {
    columnName: "asc",
    displayNameKey: "Ascending"
  }
];


